import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';

import { Button } from 'antd';

import { Field, Form, Formik } from 'formik';
import type { FormikProps } from 'formik';
import { FilterActions } from 'v2/components/Pages/Reports/FilterActions';
import { FilterPanel } from 'v2/components/Pages/Reports/FilterPanel';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { MultipleTextFormField } from 'v2/components/Shared/FormFields/MultipleTextFormField';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import chargebackService from 'v2/services/chargeback';

import { Icon } from '@eduzz/ui-antd-theme';

import { initialValues } from './initialValues';
import type { IFilter } from './initialValues';
import FilterSchema from './validations';

const statusOptions: Array<{ label: string; value: number }> = [
  { label: 'Perdido', value: 7 },
  { label: 'Aguardando Documentação', value: 10 },
  { label: 'Em Análise', value: 20 },
  { label: 'Em Processamento', value: 1 },
  { label: 'Ganho', value: 3 }
];

const ChargebackFilter = () => {
  const [isLoading] = useObservable(() => chargebackService.isLoading(), []);

  const onSubmit = useCallback((values: IFilter, { setSubmitting }: FormikProps<IFilter>) => {
    chargebackService.setFilter({ ...values });
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialValues} validationSchema={FilterSchema} onSubmit={onSubmit}>
      {({ isValid, isSubmitting, dirty, resetForm }: FormikProps<IFilter>) => (
        <Form>
          <FilterPanel id='chargeback-filter'>
            <div className='grid grid-cols-1 items-end gap-4 sm:grid-cols-2 md:grid-cols-12'>
              <div className='md:col-span-3 xl:col-span-3'>
                <Field label='Período' id='date' name='date' component={DateRangePickerFormField} />
              </div>
              <div className='md:col-span-3 xl:col-span-2'>
                <Field
                  id='customer_email'
                  name='customer_email'
                  fullWidth
                  label='E-mail do Cliente'
                  component={TextFormField}
                />
              </div>
              <div className='md:col-span-3 xl:col-span-2'>
                <Field
                  id='invoice_id'
                  name='invoice_id'
                  fullWidth
                  onlyNumbers
                  label='Fatura'
                  placeholder='Separar usando , (vírgula)'
                  component={MultipleTextFormField}
                />
              </div>
              <div className='md:col-span-3 xl:col-span-2'>
                <Field
                  id='id'
                  name='id'
                  multiple
                  options={statusOptions}
                  fullWidth
                  label='Status'
                  component={SelectFormField}
                />
              </div>
              <div className='md:col-span-12 xl:col-span-3'>
                <FilterActions>
                  <Button
                    id='clear-button'
                    loading={isLoading || isSubmitting}
                    disabled={!dirty || isSubmitting || isLoading}
                    type='text'
                    onClick={() => resetForm({ values: initialValues })}
                  >
                    Limpar
                  </Button>
                  <Button
                    id='basic-filter-button'
                    type='primary'
                    disabled={!isValid || isSubmitting || isLoading}
                    loading={isSubmitting || isLoading}
                    htmlType='submit'
                    icon={<Icon.Funnel />}
                  >
                    Filtrar
                  </Button>
                </FilterActions>
              </div>
            </div>
          </FilterPanel>
        </Form>
      )}
    </Formik>
  );
};

export default ChargebackFilter;
